<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card :class="userElevation">
          <v-toolbar dark prominent color="primary">
            <v-toolbar-title class="title">
            Config Admin
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn 
              v-if="!editMode"
              text
              dark 
              outlined
              @click="changeMode(true)">
                Edit
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-combobox
              v-model="formData.roles"
              :readonly="!editMode"
              label="Roles"
              multiple
              small-chips
              deletable-chips
            ></v-combobox>

            <v-combobox
              v-model="formData.specialty"
              :readonly="!editMode"
              :disabled="!editMode"
              label="Specialties"
              multiple
              small-chips
              deletable-chips
            ></v-combobox>

            <v-combobox
              v-model="formData.topics"
              :readonly="!editMode"
              :disabled="!editMode"
              label="Topics"
              multiple
              small-chips
              deletable-chips
            ></v-combobox>

            <v-combobox
              v-model="formData.locations"
              :readonly="!editMode"
              :disabled="!editMode"
              label="Locations"
              multiple
              small-chips
              deletable-chips
            ></v-combobox>


<!--
            <v-combobox
              v-model="formData.employer"
              :readonly="!editMode"
              :disabled="!editMode"
              label="Employers"
              multiple
              small-chips
              deletable-chips
            ></v-combobox>
-->
            <div>
              <v-toolbar flat color="white" dense>
                <v-toolbar-title class="body-1 font-weight-bold" >Employers</v-toolbar-title>
                <v-divider
                  class="mx-2"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px" v-if="editMode">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      text
                      color="primary" 
                      dark class="mb-2" 
                      v-on="on">
                      New Employer
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.employer" label="Employer"></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              v-model="editedItem.location"
                              :items="locationList"
                              label="Location"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-data-table
                :headers="headers"
                :items="formData.employer"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">{{ props.item.employer }}</td>
                  <td class="text-xs-left">{{ props.item.location }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(props.item)"
                      v-if="editMode"
                    >
                      edit
                    </v-icon>
                    <v-icon
                      small
                      @click="deleteItem(props.item)"
                      v-if="editMode"
                    >
                      delete
                    </v-icon>
                  </td>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </div>


            <br>
            <v-combobox
              v-model="formData.rejectionReasons"
              :readonly="!editMode"
              :disabled="!editMode"
              label="Reasons for turning down a relationship"
              multiple
              small-chips
              deletable-chips
            ></v-combobox>
            <v-textarea
              v-model="formData.userGuideURL"
              auto-grow
              rows=1
              :readonly="!editMode"
              label="User Guide URL">
            </v-textarea>
          </v-card-text>
          <v-card-actions v-if="editMode">
            <v-btn 
              text 
              color="secondary" 
              dark
              @click="saveChanges">Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              text 
              color="blue darken-1" 
              dark
              @click="cancelChanges">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Employer',
          align: 'left',
          sortable: true,
          value: 'employer'
        },
        {
          text: 'Location',
          align: 'left',
          sortable: true,
          value: 'location'
        }
      ],
      formData: {
//        roles: null,
  //      specialty: null,
    //    topics: null
      },
      userProfile:{
        name: null,
        email: null,
        telephone: null,
        role: null,
        specialty: null,
        location: null
      },
      editedIndex: -1,
      editedItem: {
        location: '',
        employer: ''
      },
      defaultItem: {
        location: '',
        employer: ''
      },
      emailRules: [
              v => !!v || 'Email is required',
              v => /^(?:(?:[\w`~!#$%^&*\-=+;:{}'|,?\/]+(?:(?:\.(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)*"|[\w`~!#$%^&*\-=+;:{}'|,?\/]+))*\.[\w`~!#$%^&*\-=+;:{}'|,?\/]+)?)|(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)+"))@(?:[a-zA-Z\d\-]+(?:\.[a-zA-Z\d\-]+)*|\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])$/.test(v) || 'E-mail must be valid'
            ]
    }),
    created: function() {
      this.changeMode(false)
      this.loadDataIntoForm()
    },
    computed: {
      userElevation: function () {
        if (this.editMode == true) {
          return "elevation-24"
        } else {
          return "elevation-1"
        }
      },
      configData: function () {
        // get the latest version of the configuration data from the store
        return this.$store.getters.getConfig
      },
      editMode: function () {
        // get the current edit mode for the page from the store
        return this.$store.getters.getConfigEditMode
      },
      locationList: function () {
        var list = ["All"]
        return list.concat(this.formData.locations.sort())
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Employer' : 'Edit Employer'
      }
    },
    watch: {
      editMode: function () {
        // when the edit mode changes refresh the visible data from the
        // current config data held in the store
        this.loadDataIntoForm()
      },
      dialog (val) {
        val || this.close()
      }
    },
    methods: {
      cancelChanges() {
        this.$forceUpdate();
        this.loadDataIntoForm()
        this.changeMode(false)
      },
      saveChanges() {
        this.$forceUpdate();
        //sort the role, specialty and topic Arrays
        this.formData.roles.sort();
        this.formData.specialty.sort();
        this.formData.topics.sort();
        this.formData.employer.sort();
        this.formData.locations.sort();
        //save the config data to firestore, and update the store, by dispatching an action
        this.$store.dispatch("saveConfig",this.formData)
      },
      loadDataIntoForm() {
        //console.log("Config data",this.configData)
        //console.log("Form data before",this.formData)

        //clear out formData before reloading from configData
        this.formData = {}
        //this.formData = Object.assign({},this.configData)
        this.formData = JSON.parse(JSON.stringify(this.configData))

        //console.log("Form data after",this.formData)
        //console.log("Form and config are the same - ",Object.is(this.configData,this.formData))
      },
      /* removeRole (item) {
        this.formData.roles.splice(this.formData.roles.indexOf(item), 1)
        //this.formData.roles = [...this.formData.roles]
      }, */
      changeMode (toggle) {
        // toggle the form in and out of edit mode using an mutation in the store
        this.$store.commit('setConfigEditMode',toggle)
      },
      editItem (item) {
        this.editedIndex = this.formData.employer.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.formData.employer.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.formData.employer.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.formData.employer[this.editedIndex], this.editedItem)
        } else {
          this.formData.employer.push(this.editedItem)
        }
        this.close()
      }
    }
  }
</script>

<style>

</style>
